<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2021-03-08 17:03:40
-->
<template>
  <div>
    <el-table
      style="margin-top: 30px;width: 100%;"
      size="mini"
      id="out-table"
      :data="alarmList"
      row-key="id"
      @sort-change="sortChange"
      :header-cell-style="{ background: '#e4f1ff' }"
      height="650"
    >
      <el-table-column
        type="selection"
        reserve-selection
        :selectable="checkboxInit"
        width="50"
      ></el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.serialNumber')"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <span
            style="color:#409eff;font-size:15px;"
            v-if="scope.$index !== 0"
            >{{ scope.$index }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.devicename')"
        sortable="custom"
        prop="dname"
      >
        <template slot-scope="scope">
          <span
            class="font-style"
            v-if="scope.$index !== 0"
            :title="scope.row.dname"
            >{{ scope.row.dname }}</span
          >
          <el-input
            v-else
            size="mini"
            v-model="seek.dname"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.terminalname')"
        sortable="custom"
        width="180"
        prop="dtuname"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.dtuname
          }}</span>
          <el-input
            v-else
            size="mini"
            v-model="seek.dtuname"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.variable')"
        sortable="custom"
        prop="vname"
        width="180"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.vname
          }}</span>
          <el-input
            v-else
            size="mini"
            v-model="seek.vname"
            clearable
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmList.currentvalue')" prop="val"    width="180">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.val
          }}</span>
          <!-- <el-input v-else size="mini" v-model="seek.val" clearable></el-input> -->
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmList.Triggeringconditions')"    width="180">
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.rule
          }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmList.Notificationinformation')"    width="180">
        <template slot-scope="scope">
          <span
            class="font-style"
            v-if="scope.$index !== 0"
            :title="scope.row.alarmContent"
            >{{ scope.row.alarmContent }}</span
          >
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmList.Notificationinformation2')"    width="180">
        <template slot-scope="scope">
          <span
            class="font-style"
            v-if="scope.$index !== 0"
            :title="scope.row.recoverContent"
            >{{ scope.row.recoverContent }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.starttime')"
        prop="sts"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.sts | formateTime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.endtime')"
        prop="ets"
        width="180"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span class="font-style" v-if="scope.$index !== 0">{{
            scope.row.ets | formateTime
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('lang.alarmList.Alarmstatus')"
        align="center"
        prop="state"
      >
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-tag type="success" v-if="scope.row.state == 1">{{
              $t("lang.alarmList.restored")
            }}</el-tag>
            <el-tag type="danger" v-else>{{
              $t("lang.alarmList.inalarm")
            }}</el-tag>
          </div>
          <el-select v-else size="mini" v-model="seek.state" clearable>
            <el-option
              :label="$t('lang.alarmList.restored')"
              :value="1"
            ></el-option>
            <el-option
              :label="$t('lang.alarmList.inalarm')"
              :value="0"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.alarmList.operate')" align="center" fixed="right"    width="120">
        <template slot-scope="scope">
          <el-tooltip
            v-if="scope.row.state != 1"
            effect="dark"
            placement="top-start"
            :content="$t('lang.alarmList.Handlingalarms')"
          >
            <el-button
              type="danger"
              icon="el-icon-set-up"
              circle
              v-if="scope.$index !== 0"
              @click="handleAlarm(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    >
    </pagination>
    <!-- 处理 -->
    <cont-dialog ref="contDialog" @queryKeyword="queryKeyword"></cont-dialog>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import contDialog from "./components/contDialog";
// import TableComponent from '@/components/TableComponent/index'
import { getRecord } from "@/api/cloudMonitor/alarmList";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "monitorDeviceList",
  components: {
    // TableComponent,
    pagination,
    contDialog,
  },
  mixins: [PublicComponent],
  data() {
    return {
      Gid: "",
      alarmList: [],
      deviceSelections: [],
      seek: {
        dname: "",
        dtuname: "",
        vname: "",
        val: "",
        state: "",
        sortNum: "",
      },
    };
  },
  filters: {
    formateTime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.queryKeyword();
  },
  beforeDestroy() {
    console.log("离开");
    // this.$store.dispatch('setGroupId', '')
  },
  methods: {
    // 获取报警记录
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        dname: this.seek.dname ? this.seek.dname : undefined,
        dtuname: this.seek.dtuname ? this.seek.dtuname : undefined,
        vname: this.seek.vname ? this.seek.vname : undefined,
        val: this.seek.val ? this.seek.val : undefined,
        state: this.seek.state === "" ? undefined : this.seek.state,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
      };
      getRecord(params).then((res) => {
        if (res.data.code === 0) {
          this.alarmList = res.data.data.records;
          this.total = res.data.data.total;
          this.alarmList.unshift({});
        }
      });
    },
    // 处理报警
    handleAlarm(row) {
      this.$refs.contDialog.show(row);
    },
    // 排序
    sortChange({ column, prop }) {
      console.log(prop);
      if (prop == "dname") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else if (prop == "dtuname") {
        if (column.order == "descending") {
          this.seek.sortNum = 4;
        } else {
          this.seek.sortNum = 3;
        }
      } else if (prop == "vname") {
        if (column.order == "descending") {
          this.seek.sortNum = 6;
        } else {
          this.seek.sortNum = 5;
        }
      } else if (prop == "sts") {
        if (column.order == "descending") {
          this.seek.sortNum = 8;
        } else {
          this.seek.sortNum = 7;
        }
      } else if (prop == "ets") {
        if (column.order == "descending") {
          this.seek.sortNum = 10;
        } else {
          this.seek.sortNum = 9;
        }
      } else if (prop == "state") {
        if (column.order == "descending") {
          this.seek.sortNum = 12;
        } else {
          this.seek.sortNum = 11;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    // // 获取选中项
    // handleSelectionChange(val) {
    //   this.deviceSelections = val
    // },
    //禁止第一行搜索栏选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
  },
};
</script>
<style scoped>
.font-style {
  display: inline-block;
  font-size: 0.25rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
